import { callAPI } from '../../../../services/api.service';

export interface PDFMigrationResponse {
  status: number;
  message: string;
  data?: any;
}

export const startPDFMigration = async (): Promise<PDFMigrationResponse> => {
  try {
    const response = await callAPI('admin/migration/migrate-pdfs', {}, 'POST');
    return response;
  } catch (error: any) {
    console.error('Failed to start PDF migration:', error);
    throw error;
  }
};

export const getPDFMigrationStatus = async (): Promise<PDFMigrationResponse> => {
  try {
    const response = await callAPI('admin/migration/pdf-migration-status');
    return response;
  } catch (error: any) {
    console.error('Failed to get PDF migration status:', error);
    throw error;
  }
};

export const resetPDFMigration = async (): Promise<PDFMigrationResponse> => {
  try {
    const response = await callAPI('admin/migration/reset-pdf-migration', {}, 'POST');
    return response;
  } catch (error: any) {
    console.error('Failed to reset PDF migration:', error);
    throw error;
  }
};
